import { ContainerModule, interfaces } from "inversify";
import { ProfileConnectorApis, profileConnectorRTTI } from "./Definitions";
import { ProfileConnectorImpl } from "./ProfileConnectorImpl";

export const profileConnectorModule = new ContainerModule((bind: interfaces.Bind) => {
    bind<ProfileConnectorApis>(profileConnectorRTTI).to(ProfileConnectorImpl).inSingletonScope();
});
